function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sub-nav/sub-nav-\\u91CD\\u505A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u91CD\\u505A",
  transform: "translate(13.000000, 12.000000) scale(-1, 1) translate(-13.000000, -12.000000) translate(4.000000, 3.000000)",
  fill: "#555555"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.25563945,4 C13.5883573,4.0013241 18,7.08549055 18,11.0361018 C18,13.7257783 15.9292166,16.0939557 12.7589683,17.2822616 C11.9143903,17.5988353 11.0086255,17.8246193 10.0667985,17.951635 L9.66102371,18 L9.45597544,16.259932 C10.377393,16.1644289 11.2584361,15.9594019 12.0662018,15.6566266 C14.5803653,14.7142413 16.1333333,12.9382449 16.1333333,11.0361018 C16.1333333,8.23961942 12.7939772,5.84915572 8.51831694,5.75362729 L8.25539236,5.75066214 L4,5.75066214 L4,4 L8.25563945,4 Z",
  id: "\\u8DEF\\u5F91",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "\\u4E09\\u89D2\\u5F62",
  transform: "translate(5.000000, 4.500000) rotate(-90.000000) translate(-5.000000, -4.500000) ",
  points: "5 0 9 9 1 9"
})));

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sub-nav/sub-nav-\u91CD\u505A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.4b2d13e8.svg";
export { ForwardRef as ReactComponent };